import axios from 'axios';
import { VerificationCode } from '../../login/login';
import { useCRUDController } from '../../ui/classify_structure/CRUDController';
import { Form, Button, Row, Col, Input, message, Modal } from '../../ui/ot'
import NaturePersonFormItems from '../components/nature_person_form_items'
import { useTranslation } from "react-i18next";
import { useState } from 'react';
import { useEffect } from 'react';
import { useRef } from 'react';
import dayjs from 'dayjs';

const Signup = ({
    propsForm,
    propsShowKeys = [
        { key: "number", name: "number", hidden: true, require: false },
        { key: "task_id", name: "task_id", hidden: false, require: false },
        { key: "task_name", name: "task_name", hidden: true, require: false },
        { key: "start_time", name: "start_time", hidden: true, require: false },
        { key: "begin_time", name: "begin_time", hidden: true, require: false },
        { key: "row_number_partition_date_order_task_id", name: "row_number_partition_date_order_task_id", hidden: false, require: false },
        { key: "staff_id", name: "staff_id", hidden: false, require: false },
        { key: "serial_name", name: "serial_name", hidden: false, require: false },
        { key: "staff_name", name: "staff_name", hidden: false, require: true },
        { key: "birthday", name: "birthday", hidden: false, require: false },
        { key: "lunar_birthday", name: "lunar_birthday", hidden: true, require: false },
        { key: "staff_phone", name: "staff_phone", hidden: false, require: true },
        { key: "address", name: "address", hidden: false, require: false },
        { key: "email", name: "email", hidden: false, require: true },
        { key: "task_name", name: "task_name", hidden: false, require: false },
        { key: "staff_serial_name", name: "staff_serial_name", hidden: false, require: true, },
        { key: "passport_number", name: "passport_number", hidden: false, require: true, },
        { key: "serial_name_check", name: "serial_name_check", hidden: true, require: false, },
        { key: "staff_english_name", name: "staff_english_name", hidden: true, require: false, },
        { key: "user_department_role_data", name: "user_department_role_data", hidden: true, require: false, },
        { key: "email", name: "email", hidden: false, require: false, },
        { key: "custom_line_id", name: "custom_line_id", hidden: true, require: false, },
        { key: "address", name: "address", hidden: false, require: false, },
        { key: "staff_phone", name: "staff_phone", hidden: true, require: false, },
        { key: "property_json", name: "property_json", hidden: true, require: false, },
        { key: "rfid_code_arr", name: "rfid_code_arr", hidden: true, require: false, },
        { key: "employment_time_end", name: "employment_time_end", hidden: true, require: false },
        { key: "auto_in_card_machine", name: "auto_in_card_machine", hidden: true, require: false, },
    ],
    keyPrefix = "signup",
    departmentMode = "department",
    toolBarRender = () => [],
    propsOnFormFinish = () => { }
}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    const [form_] = Form.useForm();
    const form = propsForm ?? form_;
    const [refreshToken, setRefreshToken] = useState('')
    const [ruleModalOpen, setRuleModalOpen] = useState(true)
    // 防止連點送出：兩個請求會同時通過後端的「帳號是否已被註冊」檢查，同一個身分證就被註冊兩次
    // 用 ref 擋是因為第二次點擊可能在 setSubmitting 重繪前就進來
    const submittingRef = useRef(false)
    const [submitting, setSubmitting] = useState(false)
    const onFormFinish = () => {
        if (submittingRef.current) return;
        submittingRef.current = true
        setSubmitting(true)
        const formValues = form.getFieldsValue();
        const recordset = (formValues?.recordset ?? []).map(row => ({
            ...row,
            refresh_token: refreshToken?.refresh_token ?? '',
            code: formValues?.code ?? '',
        }))
        naturePersonController.postData(recordset)
            .finally(() => {
                submittingRef.current = false
                setSubmitting(false)
            })
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (axiosMode === "post") {
            if (status === "success") {
                message.success(t('registration_success_wait_for_review'))
                propsOnFormFinish()
            }
            if (status === "error") {
                if (values?.status === 'failure' && values?.errorInfo === 'Invalid ID format') {
                    message.error(t('registration_failure_user_Invalid_ID_format'))
                    return;
                }
                if (values?.status === 'failure' && values?.errorInfo === 'User already exists') {
                    message.error(t('registration_failure_user_already_exists'))
                    return;
                } else {
                    message.error(t('registration_failure_user_already_exists_or_too_long'))
                }
                // message.success(t('registration_success_wait_for_review'))
                // propsOnFormFinish()
            }
        }

    }
    const naturePersonController = useCRUDController({
        apiRoute: '/queue_management/backend/natural_person',
        onFinish
    })
    const getRefreshToken = (refresh_mode) => {
        axios
            .get('/refresh_token',
                {
                }
            )
            .then(response => {
                setRefreshToken(response.data)
            })
            .catch((error) => {
            })
            .finally(() => {
            })
    }
    useEffect(() => {
        setRuleModalOpen(true)
        getRefreshToken()
    }, [])
    return <>
        <Modal
            title={
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <span
                        style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            background: "#2563eb",
                            color: "#fff",
                            borderRadius: "50%",
                            width: 32,
                            height: 32,
                            fontSize: 20,
                            marginRight: 8,
                        }}
                    >
                        <svg width="20" height="20" fill="none" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2a10 10 0 100 20 10 10 0 000-20zm0 18a8 8 0 110-16 8 8 0 010 16zm-.75-7.25h1.5v4h-1.5v-4zm0-6h1.5v1.5h-1.5V6.75z" /></svg>
                    </span>
                    <span style={{ fontSize: 20, fontWeight: 600, color: "#2563eb" }}>個資保護聲明</span>
                </div>
            }
            open={ruleModalOpen}
            onOk={() => setRuleModalOpen(false)}
            footer={[
                <Button key="confirm" type="primary" onClick={() => setRuleModalOpen(false)}>
                    確認
                </Button>,
            ]}
            bodyStyle={{
                padding: "24px",
                fontSize: "1rem",
                lineHeight: 1.8,
                color: "#1e293b",
                maxWidth: 480,
                margin: "0 auto",
                wordBreak: "break-word",
            }}
        >
            <div style={{
                fontSize: "1rem",
                lineHeight: 1.8,
                color: "#1e293b",
                textAlign: "left",
                padding: "0 4px",
            }}>
                <p style={{ marginBottom: 12 }}>
                    本網站遵守「個人資料保護法」規範，記錄使用者一般瀏覽時的相關行徑，包括：
                </p>
                <ul style={{
                    paddingLeft: 20,
                    marginBottom: 12,
                    fontSize: "0.95rem"
                }}>
                    <li>使用者上站的 IP 位址</li>
                    <li>使用時間</li>
                    <li>瀏覽器</li>
                    <li>瀏覽及點選資料記錄</li>
                </ul>
                <p style={{ marginBottom: 0 }}>
                    此記錄僅供網站流量和網路行為調查進行總量分析，以提昇本網站的服務品質。
                </p>
            </div>
        </Modal>
        <Form
            form={form}
            onFinish={onFormFinish}
            initialValues={{
                recordset: [
                    {
                        task_name: "註冊",
                        start_time: dayjs().format('YYYY-MM-DD HH:mm:ss'),
                        natural_person_task_data: [
                            {
                                natural_person_staff_data: [
                                    {}
                                ],
                                natural_person_area_data: [
                                    {
                                    }
                                ],
                            }
                        ]
                    }
                ]
            }}
        >
            <Form.List
                name={'recordset'}
            >
                {fields => <>
                    {fields?.map(field => <>
                        <NaturePersonFormItems
                            fieldName={field.name}
                            // formValues={form.getFieldsValues()}
                            propsCustomForm={form}
                            field={field}
                            propsOnFinish={() => { }}
                            keyPrefix={keyPrefix}
                            propsShowKeys={propsShowKeys}
                            formOnValuesChange={() => { }}
                            departmentMode={departmentMode}
                        />
                    </>)}
                </>}
            </Form.List>

            <Row gutter={[8, 8]} justify={'center'} style={{ marginBottom: 16 }}>
                <Col span={10}>
                    <Form.Item
                        name={['code']}
                        // label={t("enter_verification_code")}
                        rules={[
                            {
                                required: true,
                                message: t("enter_verification_code"),
                            },
                        ]}
                        labelCol={24}
                        wrapperCol={24}
                    >
                        <Input
                            placeholder={t("enter_verification_code")}
                            className=" border-gray-200 focus:border-blue-500 transition-all"
                        />
                    </Form.Item>
                </Col>
                <Col>
                    <VerificationCode
                        codeSrc={refreshToken?.code}
                        getRefreshToken={getRefreshToken}
                    />
                </Col>
            </Row>
            <Row gutter={[8, 8]}>
                <Col span={12}>
                    {toolBarRender().map(tool => <>
                        {tool}
                    </>)}
                </Col>
                <Col span={12}>
                    <Button
                        htmlType={"submit"}
                        type="default"
                        // onClick={() => form.submit()}
                        block={true}
                        loading={submitting}
                    >
                        {t('confirm_registration')}
                    </Button>
                </Col>
            </Row>
        </Form >
    </>
}

export default Signup